import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "faq")
    ])
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "name",
  class: "checkbox-faq"
}, null, -1)
const _hoisted_8 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faq, (fa) => {
            return (_openBlock(), _createBlock("div", {
              class: "faq__list list",
              key: fa.id
            }, [
              _createVNode("label", _hoisted_6, [
                _hoisted_7,
                _createVNode("h3", _hoisted_8, [
                  _createTextVNode(_toDisplayString(fa.title) + " ", 1 /* TEXT */),
                  _createVNode(_component_svg_icon, { name: "triangle-down" })
                ]),
                _createVNode("p", {
                  innerHTML: fa.content,
                  class: "text"
                }, null, 8, ["innerHTML"])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}